import React, { FC, useState } from "react";
import {
  Row,
  Spacer,
  Text,
  Card,
} from "@components/1-atoms";

import Illustration from "@assets/plaid-link-illustration";
import { PlaidButton } from '@lib/plaid';

import { NavigationProp } from "@react-navigation/native";


type Props = {
  navigation: NavigationProp<any>;
};

const Banking: FC<Props> = ({ navigation }) => {

  // Ask the use to take advantage of the feed feature
  return (
    <Card title="Securely connect your account(s)">

      <Spacer h={3} />
      <Illustration />
      <Spacer h={2} />

      <Row>
        <Text>Connect your accounts, and get advanced and long term insights of your finances.
        </Text>
      </Row>
      <Spacer h={2} />

      <PlaidButton inset outlined />

    </Card>
  );
};

export default Banking;
